import React, { useState, useEffect } from 'react'
import {ReactComponent as More} from '../../../assets/new-icons/plus.svg';
import {ReactComponent as Less} from '../../../assets/new-icons/minus.svg';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import { useSelector, useDispatch } from 'react-redux';
import md5 from 'md5';
import axios from 'axios';
import { setSoglia, setTaglia } from '../../../features/userSlice';


function Step2({ next }) {
    const dispatch = useDispatch()
    const customerId = useSelector((user) => user.user.info.customer_id)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const taglia = useSelector((user) => user.user.importo_taglia)
    const soglia = useSelector((user) => user.user.importo_soglia)



    useEffect(() => {
        init()
    },[])

    const init = async () => {
        const url = `https://my.revoluce.it/area_utente/gestione/api/customers/getSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(url)
        const result = data.data[0]
        dispatch(setTaglia(result.importo_taglia))
        dispatch(setSoglia(result.soglia_incasso))
    }

    const saveTagliaSoglia = async () => {
        const url = `https://my.revoluce.it/area_utente/gestione/api/customers/setSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}&soglia_incasso=${soglia}&importo_taglia=${taglia}`
        const { data } = await axios.get(url)
        next()
    }
    return (
        <>
            {taglia && soglia && (
                <>
                    <p className="main">Imposta soglia e taglia:</p>
                    <p className="secondary">Quando il tuo Saldo ( complessivo dei consumi giornalieri ) scende sotto la soglia di</p> 
                    <div className="global">
                        <span className="less" onClick={() => soglia === 5 ? null : dispatch(setSoglia(parseFloat(soglia) - 5))}><Less /></span>
                        <p className='value'>{soglia}€</p>
                        <span className="more" onClick={() => dispatch(setSoglia(parseFloat(soglia) + 5))}><More /></span>
                    </div>
                    <p className="label" style={{textAlign: 'center', marginBottom: '30px'}}>
                        La soglia non può essere inferiore a 5€
                    </p>
                    <p className="secondary">Ricaricheremo automaticamente la <span className="bold">taglia</span> di:</p> 
                    <div className="global">
                        <span className="less" onClick={() => taglia === 10 ? null : dispatch(setTaglia(parseFloat(taglia) - 5))}><Less /></span>
                        <p className='value'>{taglia}€</p>
                        <span className="more" onClick={() => dispatch(setTaglia(parseFloat(taglia) + 5))}><More /></span>
                    </div>
                    <p className="label" style={{textAlign: 'center'}}>
                        La taglia non può essere inferiore a 10€
                    </p>
                    <div className="box">
                        <p className='secondary'>
                            In base al consumo stimato mensile da te indicato faremo una ricarica di {taglia}€ ogni 11 giorni
                            con una media di 2-3 ricariche al mese. Per aumentare o diminuire la frequenza delle ricariche
                            modifica i valori di soglia e taglia.
                        </p>
                    </div>
                    <div className="buttonActivate" onClick={() => saveTagliaSoglia()}>
                        <button>Avanti <ArrowForwardIos fontSize='18px'/></button>
                    </div>
                </>
            ) }
            
        </>
    )
}

export default Step2
